import {
    useCallback,
    useMemo,
} from 'react'
import AddIcon from '@mui/icons-material/Add'

import RichTable from 'app/shared-components/RichTableReduxWrapper'
import useRequestTable from 'app/hooks/useRequestTable'
import useLoadFilters from 'app/common/DomainObject/hooks/useLoadFilters'
import Card from 'app/shared-components/Card'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import {
    TableResponse,
} from 'app/types/request.types'
import useLabel from 'app/hooks/useLabel'
import {
    Contact,
} from 'app/Apps/ContactManagement/Contacts/Contacts.types'
import useRenderTableControlPanel from 'app/shared-components/CollapsibleTable/useRenderTableControlPanel'
import useGetAccount from 'app/requests/Account/hooks/useGetAccount'
import useContactManagementRoutes from 'app/SkyNetRoutes/hooks/useContactManagementRoutes'

import request from 'app/requests/Account/Account.requests'
import columns from './contacts.columns'
import useStyles from './Contacts.style'

const Contacts = ({
    id,
}: { id: number }) => {
    const {
        Contacts: ContactsRoutes,
    } = useContactManagementRoutes()
    const {
        classes,
    } = useStyles()

    const l = useLabel()

    const {
        data: account,
    } = useGetAccount(id)

    const {
        onParamsChange,
        loadData,
    } = useRequestTable<TableResponse<Contact>>({
        key: RequestKeys.getContactsByAccount,
        params: {
            accountId: id,
        },
        config: request[RequestKeys.getContactsByAccount],
        enabled: Boolean(id),
    })

    const filterCountUrl = useMemo(() => {
        return {
            customUrl: request.filterCountRequestContacts({
                accountId: id,
            })?.url,
        }
    }, [id])

    const injectLoadFilters = useLoadFilters(filterCountUrl)

    const columnsWithFilters = useMemo(() => {
        return injectLoadFilters(columns({
            l,
        }))
    }, [
        injectLoadFilters,
        l,
    ])

    const onOpenForm = () => {
        ContactsRoutes.Create.navigate({
            options: {
                state: {
                    company: account.company,
                },
            },
        })
    }

    const renderTableControlPanel = useRenderTableControlPanel({
        title: 'Contacts',
        stateName: 'Contacts',
        createEnabled: false,
        children: <AddIcon
            onClick={onOpenForm}
            className={classes.addIcon}
        />,
    })

    const onRowClick = useCallback(({
        id: contactId,
    }: Contact) => {
        ContactsRoutes.Overview.navigate({
            params: {
                key: contactId,
            },
        })
    }, [ContactsRoutes])

    return (
        <Card>
            <RichTable
                configName="ContactsTable"
                onParamsChange={onParamsChange}
                name="Contact"
                load={loadData}
                columns={columnsWithFilters}
                uniqField="id"
                className={classes.tableContent}
                classNames={{
                    contentWrapper: classes.tableContentWrapper,
                }}
                onRowClick={onRowClick}
                renderControlPanel={renderTableControlPanel}
            />
        </Card>
    )
}

export default Contacts
